import { Button, Flex, Modal, Spin } from "antd"
import { useCallback, useEffect, memo, useState } from "react"
import { modalType } from "../../../../components/ModalGlobal";
import HttpTool from "../../../../tool/HttpTool";
import { message } from "antd";

/**
 * 硬件更新管理
 * @returns 
 */
const HardwareUpdateMange = () => {
  const [loading, setLoading] = useState(false);

  const CheckUpdateInfo = memo(() => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    useEffect(() => {
      setLoading(true);
      HttpTool.post(
        '/platform/admin/user/codeUpdate',
        (code, msg, json, option) => {
          console.log(json);
          setData(json);
          // message.success('升级成功');
          setLoading(false);
        },
        (code, msg) => {
          setLoading(false);
          Modal.warn({
            ...modalType.modalSmall,
            title: '提示',
          })
        },
        {
          check: true,
        }
      )
    }, [])
    return (
      <Spin spinning={loading}>
        <div>将向<span style={{ color: 'orange', fontSize: 20, padding: 6  }}>{data || 0}</span>个设备推送更新通知</div>
      </Spin>
    )
  })

  const updateHardware = useCallback(() => {

    Modal.confirm({
      ...modalType.modalSmall,
      title: '推送升级通知',
      content: <Flex vertical gap={8}>
        <CheckUpdateInfo />
        {/* <span>推送更新通知，刷新工作台页面</span> */}
      </Flex>,
      onOk: () => {
        console.log('ok');
        setLoading(true);
        //请求接口
        HttpTool.post(
          '/platform/admin/user/codeUpdate',
          (code, msg, json, option) => {
            console.log(json);
            setLoading(false);
            message.success('推送升级消息成功');
          },
          (code, msg) => {
            setLoading(false);
            Modal.warn({
              ...modalType.modalSmall,
              title: '提示',
            })
          },
          {}
        )
      }
    })
  }, []);

  return (
    <Flex vertical gap={32}>
      <h2>硬件升级管理</h2>

      <Flex vertical gap={16} align="center">
        <span>
          更新版本说明：将向设备推送更新通知，设备收到更新通知，将立即刷新工作台页面
        </span>
        <Button type="primary" onClick={updateHardware} loading={loading} disabled={loading}>
          更新版本
        </Button>
      </Flex>

    </Flex>
  )
}

export default HardwareUpdateMange